import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { LocalService, StatusWithId, KeyValues5, KeyValues3, KeyValues10, KeyValueSets, KeyValues15, QrLabelTemplateType, KeyValueSet, Paging, Wrappers10, ActiveInactiveFor, KeyValues30, KeyValues20 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class QrlabelService {
  private controllerName = service_controllers_methods.qrlabel.controller;
  private methods = service_controllers_methods.qrlabel.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  saveQrLabelTemplate(data: KeyValues5): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveQrLabelTemplate, body);
  }

  getQrLabelTemplate(businessId: string, qrLabelTemplateId?: string): Observable<KeyValues5> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: qrLabelTemplateId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetQrLabelTemplate, body);
  }

  getQrLabelTemplates(businessId: string, isActive: boolean): Observable<KeyValues10[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: isActive ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetQrLabelTemplates, body);
  }

  deletQrLabelTemplate(id: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: id } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.DeletQrLabelTemplate, body);
  }

  getFontOptions(): Observable<KeyValueSets[]> {
    let body = {
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetFontOptions, body);
  }

  saveQrLabelVariable(data: KeyValues20): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveQrLabelVariable, body);
  }

  getQrLabelVariable(qrLabelTemplateId: string, qrLabelVariableId?: string): Observable<KeyValues20> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: qrLabelTemplateId, v2: qrLabelVariableId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetQrLabelVariable, body);
  }

  getQrLabelVariables(qrLabelTemplateId: string, isActive: boolean): Observable<KeyValues30[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: qrLabelTemplateId, v2: isActive ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetQrLabelVariables, body);
  }

  activeInactiveStatus(iActionFor: ActiveInactiveFor, id: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: id, v2: iActionFor.toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ActiveInactiveStatus, body);
  }

  getLabelHtml(businessId: string, qrLabelTemplateType: QrLabelTemplateType, labelPrintLastSetting: KeyValues15, filterData?: any, isSample?: boolean, uploadedId?: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { isSelected: isSample == true, v1: businessId, v2: qrLabelTemplateType.toString(), v3: uploadedId } as KeyValues5,
      set: labelPrintLastSetting,
      ft: filterData
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLabelHtml, body);
  }

  getQrLabelPrintLastSetting(countryCode: string, businessId: string, qrLabelTemplateType: QrLabelTemplateType): Observable<KeyValues15> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: countryCode, v2: businessId, v3: qrLabelTemplateType.toString() } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetQrLabelPrintLastSetting, body);
  }

  getQrLabelTemplatesToDisplay(countryCode: string, businessId: string, qrLabelTemplateType: QrLabelTemplateType, isActive: boolean = true): Observable<KeyValueSet[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { isSelected: isActive, v1: countryCode, v2: businessId, v3: qrLabelTemplateType.toString() } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetQrLabelTemplatesToDisplay, body);
  }

  public getUploadedQrValues(qrTemplateId: string, paging?: Paging, isActive: boolean = true): Observable<Wrappers10> {
    let body = {
      sel: this.localService.getSelected(),
      pag: paging,
      dt: { v1: qrTemplateId, v2: isActive ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetUploadedQrValues, body);
  }
}
